import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"JOTPy","textWrapNowrap":"_9yZB8","alignRight":"BFhV6","alignCenter":"-rTfe","sizeFullWidth":"bD2LG","renderedInTable":"LGCXo","sizeOriginal":"Ygyjw","sizeContent":"-Luiw","sizeSmall":"cDU6o","sizeSmallCenter":"wYy7s","flex":"fKSm4","atomic":"j93yk","anchor":"yVBXq","embed":"ccNKR","horizontalScrollbar":"lKB77","pluginContainerMobile":"WA-Xz"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-20c8183c.js.map
